import { render, staticRenderFns } from "./TableTotalRecords.vue?vue&type=template&id=2f93a060&scoped=true&"
import script from "./TableTotalRecords.vue?vue&type=script&lang=js&"
export * from "./TableTotalRecords.vue?vue&type=script&lang=js&"
import style0 from "./TableTotalRecords.vue?vue&type=style&index=0&id=2f93a060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f93a060",
  null
  
)

export default component.exports